import { render, staticRenderFns } from "./BloqueHorario.vue?vue&type=template&id=610c9b02&scoped=true&"
import script from "./BloqueHorario.vue?vue&type=script&lang=js&"
export * from "./BloqueHorario.vue?vue&type=script&lang=js&"
import style0 from "./BloqueHorario.vue?vue&type=style&index=0&id=610c9b02&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610c9b02",
  null
  
)

export default component.exports